import { overrideChargeContants } from '../../_constants';

export function overrideCharge(state = {}, action) {
    switch (action.type) {
        case overrideChargeContants.RESET:
            return {}
        case overrideChargeContants.OVVERIDECHARGE_FETCHING:
            return {
                ...state,
                overrideChargeFetching: true,
            };
        case overrideChargeContants.OVVERIDECHARGE_FETCHED:
            return {
                ...state,
                overrideChargeFetching: false,
            };
        case overrideChargeContants.OVVERIDECHARGE_SUBMITTING:
            return {
                ...state,
                overrideChargesSubmitting: true,
            };
        case overrideChargeContants.OVVERIDECHARGE_SUBMITTED:
            return {
                ...state,
                overrideChargesSubmitting: false,
            };
        case overrideChargeContants.OVERRIDE_GET_WB:
            return {
                ...state,
                wbOverride: action.wbOverride,
            };
        case overrideChargeContants.GET_OVERRIDE_CODE:
        return {
            ...state,
            overrideCodeData: action.overrideCodeData,
        };
        case overrideChargeContants.OVERRIDE_LIST:
        return {
            ...state,
            overrideList: action.overrideList,
        };
        default:
            return state;
    }
}